import { render, staticRenderFns } from "./PerformanceReviewSubmitSignOffDialog.vue?vue&type=template&id=dc9c774c&"
import script from "./PerformanceReviewSubmitSignOffDialog.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewSubmitSignOffDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports